










// Vue
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Mixins } from 'vue-mixin-decorator';
import { mapGetters, mapActions } from 'vuex';

// Third party
import dayjs, { UnitType } from 'dayjs';
import 'dayjs/locale/es';

// Components
import Btn, { BtnColor, BtnWidth } from '@/shared/components/btn.component.vue';
import ButtonSwitch, {
  SwitchActiveColor,
} from '@/shared/components/button-switch.component.vue';
import ParticipantClientCsvModal
    from '@/manager/convocation/views/convocationDetail/participantClientCsvModal/participantClientCsvModal.view.vue';
import DropUp, {
  DropUpColorHover,
} from '@/shared/components/DropUp.component.vue';
import EmptyState from '@/shared/components/empty-state.component.vue';
import GroupFilter from '@/shared/components/GroupFilter.component.vue';
import Icon, { IconEnum } from '@/shared/components/icon.component.vue';
import Pagination from '@/shared/components/Pagination/Pagination.component.vue';
import ItemThumb, {
  TooltipColor,
} from '@/shared/components/item-thumb.component.vue';
import Tooltip from '@/shared/components/Tooltip.component.vue';
import Search from '@/shared/components/search.component.vue';
import SearchAutocomplete from '@/shared/components/SearchAutocomplete.component.vue';
import TopBar from '@/shared/components/TopBar.component.vue';
import TopModal from '@/shared/components/TopModal.component.vue';
import TableColumnOrder from '@/shared/components/TableColumnOrder.component.vue';
import SpotlightText, {
  SpotlightTextColor,
} from '@/shared/components/SpotlightText.component.vue';
import CheckIcon, {
  CheckIconColor,
} from '@/shared/components/CheckIcon.component.vue';
import Field from "@/shared/components/field.component.vue";
import FlatSelectorText, {
  FlatSelectorTextPredefinedStyle,
  FlatSelectorTextSize,
} from "@/shared/components/FlatSelectorText.component.vue";
import Modal, { ModalTitleColor } from '@/shared/components/Modal.component.vue';

// Views
import AddParticipantModal from '@/manager/convocation/views/convocationDetail/addParticipantModal/addParticipantModal.view.vue';
import ConvocationRow from '@/manager/convocation/views/convocationDetail/convocationRow/convocationRow.view.vue';
import AddNoteModal from '@/manager/convocation/views/convocationDetail/addNoteModal/addNoteModal.view.vue';
import WaitingList from '@/manager/convocation/views/convocationDetail/waitingList/waitingList.view.vue';
import ParticipantList from '@/manager/convocation/views/convocationDetail/participantList/participantList.view.vue';
import ConferenceParticipantList from '@/manager/convocation/views/convocationDetail/conferenceParticipantList/conferenceParticipantList.view.vue';
import TeamList from '@/manager/convocation/views/convocationDetail/teamList/teamList.view.vue';

// Services
import UtilsService from '@/core/services/utils.service';
import {
  ConvocationService,
  TypeOfProduct,
} from '@/manager/convocation/convocation.service';

// Constants
import Assets from '@/constants/assets.ts';
import Constants from '@/constants/constants';

// Filters
import formatDate from '@/shared/filters/formatDate.filter.ts';

// Mixins
import ColumnOrderMixin from '@/shared/mixins/columnOrder.mixin.ts';
import NotificationMessage from '@/shared/mixins/notificationMessage.mixin.ts';
import SearchMixin from '@/shared/mixins/search.mixin.ts';

// Models-Interfaces
import { Client } from '@/manager/client/client.model';
import { Convocation } from '@/manager/convocation/convocation.model';
import { TimetablesInterface } from '@/shared/interfaces/timetables.interface';
import { SecondLevelOptionModel } from '@/shared/models/secondLevelOption.model';
import { CounterInterface } from '@/shared/components/counter/counter.interface.ts';
import { Participant } from '@/manager/convocation/participant.model';
import { CounterColor } from '@/shared/components/counter/counter.enum.ts';
import PostponeList from './postponeList/postponeList.view.vue';

@Component({
  components: {
    ParticipantClientCsvModal,
    AddNoteModal,
    AddParticipantModal,
    Btn,
    CheckIcon,
    ConferenceParticipantList,
    ConvocationRow,
    ButtonSwitch,
    DropUp,
    EmptyState,
    Field,
    GroupFilter,
    Icon,
    ItemThumb,
    Modal,
    Pagination,
    ParticipantList,
    Search,
    SearchAutocomplete,
    SpotlightText,
    TableColumnOrder,
    TeamList,
    Tooltip,
    TopBar,
    TopModal,
    WaitingList,
    PostponeList,
    FlatSelectorText
  },
  computed: {
    ...mapGetters({
      profile: 'getProfile',
      getConvocation: 'getConvocation',
      getNextConvocationList: 'getNextConvocationList',
      getParticipantList: 'getParticipantList',
      delegationList: 'getDelegationList',
      isOpenNavbar: 'isOpenNavbar',
      hasServerError: 'hasServerError',
      getServerError: 'getServerError',
    }),
  },
  filters: {
    formatDate,
  },
})
export default class ConvocationDetail extends Mixins<NotificationMessage>(
  NotificationMessage,
) {
  @Prop() private id!: string;

  private assets = Assets;
  private searchString = new URLSearchParams(window.location.href.split('?')[1]) && new URLSearchParams(window.location.href.split('?')[1]).get('search-string') ? new URLSearchParams(window.location.href.split('?')[1]).get('search-string') : '';
  private searchNifString = '';
  private dropUpColorHover = DropUpColorHover;
  private tooltipColor = TooltipColor;
  private convocation = new Convocation();
  private iconEnum = IconEnum;
  private btnColor = BtnColor;
  private btnWidth = BtnWidth;
  private flatSelectorTextPredefinedStyle = FlatSelectorTextPredefinedStyle;
  private flatSelectorTextSize = FlatSelectorTextSize;
  private modalTitleColor = ModalTitleColor;
  private getConvocation!: any;
  private profile!: any;
  private getNextConvocationList!: Convocation[];
  private disableTooltipAvatar = true;
  private loadingGroupFilters = true;
  private getParticipantList!: Participant[];
  private tagList!: any;
  private statesConvocations: any = [];
  private delegationList!: any;
  private isOpenNavbar!: any;
  private hasServerError!: any;
  private getServerError!: any;
  private addParticipantModalOpened = false;
  private addNoteModalOpened = false;
  private getProfile!: any;
  private lastNoteTyped: string = '';
  private searchClient = '';
  private selectedClient = null;
  private utilsService = UtilsService;
  private interval!: any;
  private spotlightTextColor = SpotlightTextColor;
  private cleanSearch = false;
  private participantListLoaded = false;
  private participantList = { count: 0 };
  private waitingListLoaded = false;
  private postponeListLoaded = false;
  private teamListLoaded = false;
  private teamList = { count: 0 };
  private convocationLoaded = false;
  private waitingList = { count: 0 };
  private postponeList = { count: 0 };
  private conferenceListLoaded = false;
  private conferenceList = { count: 0 };
  private showingTeamList: boolean = false;
  private listSwitchOptionSelected = this.listSwitchOptions[0];
  private newParticipantAdded: boolean = false;
  private headerClass = '';
  private tableResponsiveStart!: any;
  private columnsVisibility = {
    number: true,
    firstName: true,
    lastName: true,
    tag: true,
    phone: false,
    observations: true,
    paymentStatus: false,
    communications: true,
    postponement: true,
    topLevelPack: true,
    powerPack: true,
    toWatingList: true,
    lastActions: true,
    state: false,
    largeButton: false,
    email: false,
    secondLastName: false,
    nif: false,
    town: false,
    origin: false,
  };
  private alertDisplace = false;
  private paymentStatusOptions!: any[];
  private checkIconColor = CheckIconColor;
  private stateSelected:any;
  private stateConvocationSendEmail:boolean = false;
  private auxStateConvocation!:any;
  private participantToWaitingList:boolean = false;

  @Watch('isOpenNavbar')
  private watchIsOpenNavbar(newVal: boolean, oldVal: boolean) {
    this.calculateHeaderClass();
    this.checkObservationsVisibility();
    this.tableResponsiveStart = Date.now();
    window.requestAnimationFrame(this.tableResponsiveStep);
  }

  @Watch('$route.query.team')
  private watchQueryParamTeam(newVal: boolean, oldVal: boolean) {
    this.showingTeamList = newVal;
  }


  @Watch('searchString')
  private watchSearchString(newVal: string, oldVal: string) {
    if (newVal === '') {
      this.participantListLoaded = false;
      this.waitingListLoaded = false;
      this.postponeListLoaded = false;
      this.teamListLoaded = false;
    }
  }

  @Watch('searchNifString')
  private watchSearchNifString(newVal: string, oldVal: string) {
    if (newVal === '') {
      this.participantListLoaded = false;
      this.waitingListLoaded = false;
      this.postponeListLoaded = false;
      this.teamListLoaded = false;
    }
  }

  @Watch('id')
  private watchConvocationId(newVal: string, oldVal: string) {
    this.convocationLoaded = false;
    this.initializeComponent();
  }

  private created() {
    this.initializeComponent();
  }

  get hideWaitingList() {
    return this.profile.email === 'recordartefotografia@gmail.com';
  }

  get hidePostponeList() {
    return !this.convocation.isPendingPostponeList;
  }

  get openModal() {
      return this.addParticipantModalOpened || this.addNoteModalOpened || this.participantClientModalOpened;
  }

  get listSwitchOptions(): any[] {
    return [
      { id: 1, text: 'Asistentes', activeColor: SwitchActiveColor.Primary },
      { id: 2, text: 'Equipo' },
    ];
  }
    private participantClientCsvError(message: string) {
        this.showNotification(message, this.spotlightTextColor.Error);
    }
    get participantClientModalOpened() {
        return !!this.$route.query['participant-uploaded-details']
    }
  get prevConvocation() {
    let prev = 'default-id';
    if (this.convocation.prevConvocation) {
      prev = this.convocation.prevConvocation;
    }
    return prev;
  }

  get nextConvocation() {
    let next = 'default-id';
    if (this.convocation.nextConvocation) {
      next = this.convocation.nextConvocation;
    }
    return next;
  }

  get showConferenceParticipantList() {
    return !this.showingTeamList && this.isConference;
  }

  get showParticipantList() {
    return (
      !this.showingTeamList &&
      this.convocationLoaded &&
      (this.isCourse || this.isEvent)
    );
  }

  get showWaitingList() {
    return (
      !this.hideWaitingList &&
      !this.showingTeamList &&
      this.participantListLoaded &&
      (this.isCourse || this.isEvent)
    );
  }

  get showPostponeList() {
    return (
      !this.hidePostponeList &&
      !this.showingTeamList &&
      this.participantListLoaded &&
      (this.isCourse || this.isEvent)
    );
  }

  get showTeamList() {
    return this.showingTeamList;
  }

  get tooltipAvatarText() {
    let result = 'Sin trainer asignado';
    this.disableTooltipAvatar = true;
    if (
      this.convocation !== undefined &&
      this.convocation.trainer !== null &&
      this.convocation.trainer !== undefined &&
      this.convocation.trainer.firstName !== null
    ) {
      this.disableTooltipAvatar = false;
      const trainer = this.convocation.trainer;
      result = `${trainer.firstName} ${trainer.lastName}`;
    }
    return result;
  }

  get itemTooltipColor() {
    let color = TooltipColor.Primary;
    if (this.isConference) {
      color = TooltipColor.Secondary;
    }
    return color;
  }

  get convocationDate() {
    return (this.convocation as any).timetables[0];
  }

  get convocationStartHour() {
    const timeStart = this.convocationDate.timeStart;
    const splittedTime = timeStart.split(':');

    return `${splittedTime[0]}:${splittedTime[1]}h`;
  }

  get avatar() {
    let result = this.assets.defaultAvatar;
    if (
      this.convocation !== undefined &&
      this.convocation.trainer !== null &&
      this.convocation.trainer !== undefined &&
      this.convocation.trainer.profile !== undefined &&
      this.convocation.trainer.profile.avatar !== null
    ) {
      result = this.convocation.trainer.profile.avatar;
    }
    return result;
  }

  get title() {
    let result: string | undefined = '...';
    if (this.convocation.product !== undefined) {
      result = this.convocation.product.name;
    }
    return result;
  }

  get location() {
    let result: string | undefined = 'Sin ubicación';
    if (this.convocation.location) {
      result = this.convocation.location.name;
    }
    return result;
  }

  get isConference() {
    return ConvocationService.convocationIsProductType(
      this.convocation,
      TypeOfProduct.Conference,
    );
  }

  get isCourse() {
    return ConvocationService.convocationIsProductType(
      this.convocation,
      TypeOfProduct.Course,
    );
  }

  get isEvent() {
    return ConvocationService.convocationIsProductType(
      this.convocation,
      TypeOfProduct.Event,
    );
  }

  get initialNextConvocationListIndex() {
    let index = 0;
    if (this.convocation.delegation) {
      index = this.delegationList
        .map((delegation: any) => {
          return delegation.id;
        })
        .indexOf(this.convocation.delegation.id);
    }
    return index;
  }

  get parsedNextConvocationListOptions() {
    const sortedNextConvocationList = this.getNextConvocationList.sort(
      (convocation1: any, convocation2: any) => {
        if (convocation1.timetables[0].date < convocation2.timetables[0].date) {
          return -1;
        }
        if (convocation1.timetables[0].date > convocation2.timetables[0].date) {
          return 1;
        }
        return 0;
      },
    );
    const parsedResult = this.delegationList.map((delegation: any) => {
      const delegationOptions = sortedNextConvocationList
        .filter((convocation: any) => {
          return convocation.delegation.id === delegation.id;
        })
        .map((convocation: any) => {
          const formattedConvocationDates: any = this.formatConvocationDates(
            convocation,
          );
          return new SecondLevelOptionModel(
            convocation.id,
            formattedConvocationDates,
            false,
            '',
            false,
          );
        });
      const option = {
        value: delegation.id,
        label: delegation.name,
        disabled: delegationOptions.length === 0,
        options: delegationOptions,
      };
      return option;
    });
    return parsedResult;
  }

  get isLive(): boolean {
    let val = false;
    const now = dayjs();
    const timetables = this.convocation.timetables;
    if (timetables) {
      for (const timetable of timetables) {
        const dayjsDate = dayjs(timetable.date, { locale: 'es' });
        const dateDiff = now.diff(dayjsDate, 'days' as UnitType);
        if (dateDiff >= 0) {
          val = true;
          break;
        }
      }
    }
    return val;
  }

  get isBeforeConfirmationPeriod(): boolean {
    let val = false;
    let now = dayjs();
    const confirmationDate = this.convocation.confirmationDate;
    if (confirmationDate) {
      let dayjsDate = dayjs(confirmationDate, { locale: 'es' });
      now = this.utilsService.setTimeToCero(now);
      dayjsDate = this.utilsService.setTimeToCero(dayjsDate);
      if (now.diff(dayjsDate, 'days' as UnitType) < 0) {
        val = true;
      }
    } else {
      val = true;
    }
    return val;
  }

  get isFirstDay(): boolean {
    let result = false;
    const now = dayjs();
    const timetables = this.convocation.timetables;
    if (timetables) {
      const firstDay = dayjs(timetables[0].date, { locale: 'es' });
      if (now.diff(firstDay, 'days' as UnitType) === 0) {
        result = true;
      }
    }
    return result;
  }

  get existsUrlMap(): boolean {
    return this.convocation.urlMap !== null;
  }

  get convocationDateFormated(){
    if (this.convocation.timetables && this.convocation.timetables[0].date && this.convocation.timetables[0].date !== undefined) {
      return formatDate(this.convocation.timetables[0].date, "DD MMM YY")
    }
  }

  get convocationBackUrl() {
      const url = window.location.origin + "/api/admin/convocation/convocation/" + this.convocation.id + "/change"
      return url
  }

  private participantListLoadedEvent(list: any) {
    this.participantListLoaded = true;
    this.participantList = list;
  }

  private waitingListLoadedEvent(list: any) {
    this.waitingListLoaded = true;
    this.waitingList = list;
  }

  private postponeListLoadedEvent(list: any) {
    this.postponeListLoaded = true;
    this.postponeList = list;
  }

  private teamListLoadedEvent(list: any) {
    this.teamListLoaded = true;
    this.teamList = list;
  }

  private tableResponsiveStep(timestamp: any) {
    const progress = timestamp - this.tableResponsiveStart;
    this.tableResponsive();
    if (progress < 400) {
      requestAnimationFrame(this.tableResponsiveStep);
    }
  }

  private recalculateResponsive() {
    this.calculateHeaderClass();
    this.checkObservationsVisibility();
    Vue.nextTick(() => {
      this.tableResponsive();
    });
  }

  private eventShowTable(value: boolean) {
    if (value) {
      this.recalculateResponsive();
    }
  }

  private checkToShowTeamList() {
    const teamParam = this.$route.query.team;
    this.showingTeamList = teamParam === 'true';
    if (this.showingTeamList) {
      this.listSwitchOptionSelected = this.listSwitchOptions[1];
    }
  }

  private initializeComponent() {
    this.checkToShowTeamList();
    this.paymentStatusOptions = [];
    setTimeout(() => {
      this.fetchConvocation(() => {
        this.convocationLoaded = true;
        this.columnsVisibility.paymentStatus =
          this.convocation !== undefined &&
          this.convocation.product !== undefined &&
          this.convocation.product.level >= 2;
        if (this.columnsVisibility.paymentStatus) {
          this.fetchPaymentStatus();
        }
        this.fetchDelegationList(() => {
          this.fetchNextConvocationList(this.convocation);
        });
        this.timeoutMethods();
      });
      this.fetchTagList();
      this.fetchStatesConvocations();
    }, 0);
  }

  private fetchStatesConvocations() {
    this.$store.dispatch("fetchStatesConvocations").then(res => {
      setTimeout(() => {
        this.statesConvocations = res.results.filter((item:any) => item.type.find((type:any) => type == this.convocation.product.typeOfProduct))
      }, 500);
    });
  }

  private parsePaymentStatusToFlatSelectorTextOption(paymentStatusList: any) {
    paymentStatusList.map((paymentStatus: any) => {
      const option = {
        value: paymentStatus.id,
        label: paymentStatus.name,
        colorSelected: '',
      };
      if (paymentStatus.name === 'Cancelado') {
        option.colorSelected = 'red';
      }
      if (
        paymentStatus.name === 'Completado' ||
        paymentStatus.name === 'En marcha'
      ) {
        option.colorSelected = 'primary';
      }
      this.paymentStatusOptions.push(option);
    });
  }

  private fetchPaymentStatus() {
    this.$store.dispatch('fetchPaymentStatus').then((res) => {
      this.parsePaymentStatusToFlatSelectorTextOption(res.results);
    });
  }

  private calculateHeaderClass() {
    const windowWidth = window.innerWidth;
    let headerClass = '';
    if (windowWidth < 1250 || (windowWidth < 1440 && this.isOpenNavbar)) {
      headerClass = 'header--too-narrow';
    }
    window.setTimeout(() => {
      this.headerClass = headerClass;
    }, 0);
  }

  private checkObservationsVisibility() {
    const windowWidth = window.innerWidth;
    let visibility = true;
    if (windowWidth < 1408 || (windowWidth < 1600 && this.isOpenNavbar)) {
      visibility = false;
    }
    window.setTimeout(() => {
      this.columnsVisibility.observations = visibility;
    }, 0);
  }

  private handleResize() {
    this.calculateHeaderClass();
    this.checkObservationsVisibility();
    Vue.nextTick(() => {
      this.tableResponsiveStart = Date.now();
      window.requestAnimationFrame(this.tableResponsiveStep);
    });
  }

  private mounted() {
    window.addEventListener('resize', this.handleResize);
  }

  private beforeDestroy() {
    clearInterval(this.interval);
    window.removeEventListener('resize', this.handleResize);
  }

  private tableResponsive() {
    const topBarNode = this.$el.querySelector('.top-bar');
    const tableNodes = this.$el.querySelectorAll('.table');

    tableNodes.forEach((tableNode: any) => {
      this.tableResponsiveConfig(topBarNode, tableNode);
    });
  }

  private elementVisible(element: any) {
    return element.offsetWidth > 0 && element.offsetHeight > 0;
  }

  private tableResponsiveConfig(topBarNode: any, tableNode: any) {
    if (topBarNode && tableNode && this.elementVisible(tableNode)) {
      const tableWidths = {
        availaible: topBarNode.clientWidth,
        assigned: 0,
        toAssign: 0,
        first: 0,
        firstName: 0,
        lastName: 0,
        tags: 0,
        phone: 0,
        observations: 0,
        paymentStatus: 0,
        communication: 0,
        posponement: 0,
        tlp: 0,
        toWaitingList: 0,
        lastIcons: 0,
      };
      const tableRowHeaderNode = tableNode.querySelector('.table-row--header');
      if (tableRowHeaderNode) {
        const tableFirstColumnNode = tableRowHeaderNode.querySelector(
          '.table-cell--first',
        );
        const tableFirstNameColumnNode = tableRowHeaderNode.querySelector(
          '.table-cell--first-name-convocation',
        );
        const tableLastNameColumnNode = tableRowHeaderNode.querySelector(
          '.table-cell--last-name-convocation',
        );
        const tableTagsColumnNode = tableRowHeaderNode.querySelector(
          '.table-cell--tag-convocation-header',
        );
        const tablePhoneColumnNode = tableRowHeaderNode.querySelector(
          '.table-cell--phone-convocation',
        );
        const tableObservationsColumnNode = tableRowHeaderNode.querySelector(
          '.table-cell--observations',
        );
        const tablePaymentStatusColumnNode = tableRowHeaderNode.querySelector(
          '.table-cell--payment-status',
        );
        const tableCommunicationColumnNode = tableRowHeaderNode.querySelector(
          '.table-cell--communication-convocation',
        );
        const tablePosponementColumnNode = tableRowHeaderNode.querySelector(
          '.table-cell--postponement-convocation',
        );
        const tableTlpColumnNode = tableRowHeaderNode.querySelector(
          '.table-cell--top-level-pack-convocation',
        );
        const tableToWaitingListColumnNode = tableRowHeaderNode.querySelector(
          '.table-cell--to-waiting-list-convocation',
        );
        const tableLastIconsNormalColumnNode = tableRowHeaderNode.querySelector(
          '.table-cell--last-icons-convocation',
        );
        const tableLastIconsFutureColumnNode = tableRowHeaderNode.querySelector(
          '.table-cell--last-icons-convocation--future',
        );
        let tableLastIconsColumnNode = tableLastIconsNormalColumnNode;

        if (tableLastIconsFutureColumnNode) {
          tableLastIconsColumnNode = tableLastIconsFutureColumnNode;
        }
        if (
          tableFirstColumnNode &&
          tableFirstNameColumnNode &&
          tableLastNameColumnNode &&
          tableTagsColumnNode &&
          tablePhoneColumnNode &&
          (this.showingTeamList ||
            !this.columnsVisibility.observations ||
            tableObservationsColumnNode) &&
          (this.showingTeamList ||
            !this.columnsVisibility.paymentStatus ||
            tablePaymentStatusColumnNode) &&
          tableCommunicationColumnNode &&
          tablePosponementColumnNode &&
          tableTlpColumnNode &&
          (this.showingTeamList || tableToWaitingListColumnNode) &&
          tableLastIconsColumnNode
        ) {
          tableWidths.first = tableFirstColumnNode.clientWidth;
          tableWidths.phone = tablePhoneColumnNode.clientWidth;
          tableWidths.observations = tableObservationsColumnNode
            ? tableObservationsColumnNode.clientWidth
            : 0;
          tableWidths.paymentStatus = tablePaymentStatusColumnNode
            ? tablePaymentStatusColumnNode.clientWidth
            : 0;
          tableWidths.communication = tableCommunicationColumnNode.clientWidth;
          tableWidths.posponement = tablePosponementColumnNode.clientWidth;
          tableWidths.tlp = tableTlpColumnNode.clientWidth;
          tableWidths.toWaitingList = tableToWaitingListColumnNode
            ? tableToWaitingListColumnNode.clientWidth
            : 0;
          tableWidths.lastIcons = tableLastIconsColumnNode.clientWidth;
          tableWidths.assigned =
            tableWidths.first +
            tableWidths.phone +
            tableWidths.observations +
            tableWidths.paymentStatus +
            tableWidths.communication +
            tableWidths.posponement +
            tableWidths.tlp +
            tableWidths.toWaitingList +
            tableWidths.lastIcons;
          tableWidths.toAssign =
            tableWidths.availaible - tableWidths.assigned + 24;
          let widthToAssignItem = Math.floor(tableWidths.toAssign / 4);
          if (widthToAssignItem < 138) {
            widthToAssignItem = 138;
          }
          let widthToAssignLastItem = widthToAssignItem - 24;
          if (tableWidths.toAssign % 4 !== 0) {
            if (widthToAssignLastItem + (tableWidths.toAssign % 4) < 138 - 24) {
              widthToAssignLastItem = 138 - 24;
            }
          }
          (tableFirstNameColumnNode as HTMLElement).style.width =
            widthToAssignItem + 'px';
          (tableLastNameColumnNode as HTMLElement).style.width =
            2 * widthToAssignItem + 'px';
          (tableTagsColumnNode as HTMLElement).style.width =
            widthToAssignLastItem + 'px';
        }
      }
    }
  }

  private newParticipant() {
    this.showNotification('Asistente añadido con éxito');
    this.newParticipantAdded = true;
    this.refetchLists();
  }

  private refetchLists() {
    this.fetchConvocationHeaders();

    const participantListComponent = this.$refs.participantListComponent;
    const waitingListComponent = this.$refs.waitingListComponent;
    const postponeListComponent = this.$refs.postponeListComponent;
    const teamListComponent = this.$refs.teamListComponent;
    const conferenceParticipantListComponent = this.$refs
      .conferenceParticipantListComponent;

    if (
      participantListComponent !== undefined &&
      waitingListComponent !== undefined &&
      postponeListComponent !== undefined
    ) {
      (participantListComponent as ParticipantList).fetchFirstPageList();
      (waitingListComponent as WaitingList).fetchFirstPageList();
      (postponeListComponent as PostponeList).fetchFirstPageList();
    } else if (conferenceParticipantListComponent !== undefined) {
      (conferenceParticipantListComponent as ConferenceParticipantList).fetchFirstPageList();
    } else if (teamListComponent !== undefined) {
      (teamListComponent as TeamList).fetchFirstPageList();
    }
  }

  private onError(
    message: string = 'Estamos sufriendo algún problema... inténtalo de nuevo',
  ) {
    this.showNotification(message, this.spotlightTextColor.Secondary);
  }

  private formatConvocationDates(convocation: Convocation): string {
    return ConvocationService.formatDates(
      convocation.timetables as TimetablesInterface[],
    );
  }

  private setAddNoteModalOpened(value: boolean) {
    this.addNoteModalOpened = value;
  }
    private setParticipantClientModalOpened() {
        this.$router.push(this.$route.path)
    }
  private setAddParticipantModalOpened(value: boolean) {
    this.addParticipantModalOpened = value;
  }

  private openParticipantModal() {
    const participantsToCall = this.convocation.participantsToCall;
    const participantsSummoned = this.convocation.totalParticipantSummoned;
    if (
      participantsToCall &&
      participantsSummoned &&
      Number(participantsToCall) === Number(participantsSummoned)
    ) {
      const message = 'Cupo completo, convocatoria cerrada';
      this.showNotification(message, this.spotlightTextColor.Secondary);
    } else {
      this.setAddParticipantModalOpened(true);
    }
  }

  private timeoutMethods() {
    if (this.isFirstDay) {
      let remainingTime = Constants.timeoutMethodsRemainingTimePro;
      if (this.utilsService.inDebug()) {
        remainingTime = Constants.timeoutMethodsRemainingTimeDev;
      }
      this.interval = setInterval(() => {
        this.fetchConvocationHeaders();
        this.fetchParticipantChecked();
      }, remainingTime);
    }
  }

  private fetchParticipantChecked() {
    this.$store.dispatch('fetchParticipantChecked', { convocationId: this.id });
  }

  private fetchConvocation(
    callback: any = () => {
      const doNothing = 1;
    },
  ) {
    this.loadingGroupFilters = true;
    this.$store
      .dispatch('fetchConvocation', {
        id: this.id,
      })
      .then((res: any) => {
        this.loadingGroupFilters = false;
        this.convocation = Object.assign({}, res);
        callback();
      });
  }

  private fetchTagList() {
    this.$store.dispatch('fetchTagList',{limit: 1000});
  }

  private fetchNextConvocationList(convocation: Convocation) {
    this.$store.dispatch('fetchNextConvocationList', {
      id: convocation.id,
    });
  }

  private fetchDelegationList(
    callback: any = () => {
      const doNothing = 1;
    },
  ) {
    this.$store.dispatch('fetchDelegationList').then((res: any) => {
      callback();
    });
  }

  private updateHeaders() {
    this.convocation = this.getConvocation(this.id);
  }

  private fetchConvocationHeaders() {
    this.$store.dispatch('fetchConvocationHeaders', {
      id: this.convocation.id,
    });
    this.updateHeaders();
  }

  /**
   * Update convocation call
   * @param callback 
   */
  private updateConvocation() {
    this.$store.dispatch(
      'updateConvocation',
      this.convocation,
    ).then((res: any) => {
    });
  }

  /**
   * Check if state selected has to send email or save
   * @param state State id
   */
  private checkNewValueStatesConvocation(state:any){
    let newState = this.statesConvocations.filter((item: any) => (item.id == state))[0]
    const flatSelectorText = this.$refs.statesSelector as FlatSelectorText
    flatSelectorText.optionSelected = undefined;
    flatSelectorText.assignOptionSelected();
    if (newState.communication && this.convocation.states.filter((item: any) => item.id == state).length == 0) {
      this.auxStateConvocation = newState;
      this.toogleStateConvocationSendEmail(true);
    } else {
      this.changeStatesConvocation(newState);
    }
  }

  /**
   * Update current convocation.states 
   * @param stateId state id
   * @param newState State object
   */
  private changeStatesConvocation(newState:any, ){
    if(this.convocation.states.filter((item: any) => item.id == newState.id).length == 0){
      this.convocation.states.push(newState);
    } else {
      this.convocation.states = this.convocation.states.filter((item: any) => item.id != newState.id);
    }
    this.updateConvocation();
  }

  private listSwitchOptionChange(option: any) {
    this.listSwitchOptionSelected = option;
    let query = {};
    if (option.id === this.listSwitchOptions[1].id) {
      query = { team: true };
    }
    this.$router.push({ name: this.$route.name, query });
  }

  private showMessage(message: string) {
    this.showNotification(message, this.spotlightTextColor.Secondary);
  }

  private topBarScrolled(scrolled: boolean) {
    this.alertDisplace = scrolled;
  }

  private toogleStateConvocationSendEmail(value:boolean){
    this.stateConvocationSendEmail = value;
  }

  /**
   * Action response EmailState modal
   * @param value boolean
   */
  private checkSendEmailStateConvocation(value:boolean){
    this.auxStateConvocation['sendEmail']=value;
    this.changeStatesConvocation(this.auxStateConvocation)
    this.toogleStateConvocationSendEmail(false);
    this.auxStateConvocation = undefined;
  }

  private addParticipantToWaitingList(value:boolean){
    if(value){
      this.participantToWaitingList = true;
      this.setAddParticipantModalOpened(true);
    }
  }
}
